import api from "services/api";
import serveRequestErrors from "common/serve-request-errors";

const getEmployeeListing = async () => {
	let response = null;
	let errorMessage = null;

	try {
		const res = await api.get.admin.employeeList();
		const content = res.map(o => ({
			id: o.id,
			label: o.name,
			value: o.email,
		}));
		response = { content };
	} catch (error) {
		errorMessage = serveRequestErrors(error);
	}

	if (response) return response;
	throw errorMessage;
};

export default getEmployeeListing;
